<template>
    <div class="two-member-list-container">
      <van-nav-bar 
        title="二级推广组列表" 
        left-text="" 
        left-arrow 
        @click-left="onClickLeft" 
        @click-right="onClickRight"
        :style="{ backgroundColor: '#FFD700', color: '#333333' }"
        :title-style="{ color: '#333333' }"
        :left-arrow-style="{ color: '#333333' }"
      />
      
      <div class="content-wrapper">
        <!-- 搜索区域 -->
        <div class="search-section">
          <van-search class="search-bar" v-model="search" @search="onSearch" shape="round" show-action placeholder="输入组长ID" v-if="!!selfInfo">
            <template #action>
              <div @click="onSearch" class="search-btn">搜索</div>
            </template>
          </van-search>
          
          <!-- 搜索类型选择 -->
          <div class="search-type-wrapper">
            <van-radio-group v-model="checked" class="radio-group" direction="horizontal">
              <van-radio name="0" icon-size="14px" class="radio-item">组长ID</van-radio>
              <van-radio name="2" icon-size="14px" class="radio-item">上级组长ID</van-radio>
            </van-radio-group>
          </div>
        </div>
        
        <!-- 成员列表 -->
        <van-list v-if="!!selfInfo" class="member-list" v-model:loading="loading" :immediate-check="false"
          :finished="finished" finished-text="没有更多了" @load="onLoad">
          
          <!-- 成员卡片 -->
          <div class="member-card" v-for="(li, i) in list" :key="i">
            <!-- 成员头部信息 -->
            <div class="member-header">
              <div class="avatar-container">
                <img :src="li.userInfo.portrait ? (config!=null ?config.fileServerUrl:'') + li.userInfo.portrait : muser" alt="头像" class="avatar" />
              </div>
              <div class="member-info">
                <h3 class="member-name">{{ li.userInfo.nickName }}</h3>
                <p class="join-time">加入时间：{{ getDisplayJoinTime(li.joinTime) }}</p>
              </div>
            </div>
            
            <!-- 成员数据信息 -->
            <div class="member-data">
              <div class="data-item" @click="onUidTapped(li)">
                <div class="data-value">{{ li.userId }}</div>
                <div class="data-label">组长ID</div>
              </div>
              <div class="data-item" @click="onParentIdTapped(li)">
                <div class="data-value">{{ li.num }}</div>
                <div class="data-label">人数</div>
              </div>
              <div class="data-item" @click="onUidTapped(li)">
                <div class="data-value">{{ li.preOwnerId }}</div>
                <div class="data-label">上级组长ID</div>
              </div>
            </div>
            
            <!-- 操作按钮 -->
            <div class="action-buttons">
              <div class="action-btn income-btn" @click="onIncomeTapped(li)">
                <i class="icon-income">📊</i> 查看流水
              </div>
            </div>
          </div>
        </van-list>
        
        <!-- 确认弹窗 -->
        <van-popup v-model:show="confirm" :close-on-click-overlay="true">
          <div class="confirm-dialog">
            <div class="confirm-content">是否确认{{ isEnable ? '启用' : '禁用' }}该用户？</div>
            <van-button type="success" round size="small" @click="onConfirmTapped">确认</van-button>
          </div>
        </van-popup>
      </div>
      
      <Mask v-if="marke"></Mask>
    </div>
  </template>
  <script>
  import muser from "@/assets/image/user.png";
  // import { wxqq } from '../utils/utils'
  import Mask from '../components/Mask'
  import routerUtil from '../utils/routerUtil'
  import { Toast } from "vant";
  import copy from 'copy-to-clipboard';

  export default {
    name: 'MemberList',
    data() {
      return {
        search: '',
        checked: '0',
        muser,
        selfInfo: null,
        groupInfo: null,
        searchType: 0,
        searchUid: null,
        loading: false,
        finished: false,
        refreshing: false,
        list: [],
        confirm: false,
        item: null,
        isEnable: false,
        marke: false,
      }
    },
    components: {
      Mask,
    },
    computed: {
      config: () => {
        return JSON.parse(localStorage.getItem("config"));
      },
    },
    mounted() {
      this.reqInfo()
      // this.marke = wxqq()
    },
    methods: {
      reqInfo() {
        Promise.all([this.$request.post('/api/user/mine/userInfo'), this.$request.postJson('/api/user/pay_group/info', {})])
          .then((values) => {
            if (values[0].data.code == 0 && values[1].data.code == 0) {
              this.selfInfo = values[0].data.data;
              this.groupInfo = values[1].data.data;
              if (!this.groupInfo) {
                Toast('暂无推广组信息');
                routerUtil.back()
                return;
              }
              this.getList()
            }
          });
      },
      getList(type) {
        // eslint-disable-next-line no-debugger
        // debugger
        let lastId = null
        if (type && this.list.length > 0) {
          lastId = this.list[this.list.length - 1].id
        }
        this.$request.postJson('/api/user/pay_group/member/twolist', {
          groupId: this.groupInfo.id,
          type: this.searchType,
          userId: this.searchUid == null ? 0 : this.searchUid,
          lastId: lastId,
          pageSize: 15
        }).then((res) => {
          console.log('二级推广组====>',res)
          if (res.data.code == 0) {
            if (res.data.data.users.length == 0) {
              this.loading = false;
              this.refreshing = false
              this.finished = true;
              return
            }
            const uids = [];
            for (let user of res.data.data.users) {
              uids.push(user.userId);
              console.log('用户ID',uids)
            }
            this.$request.post('/api/user/info/userInfoByGroup', { userIds: JSON.stringify(uids) })
              .then((res1) => {
                this.loading = false
                this.refreshing = false
                if (res1.data.code == 0) {
                  const userMap = new Map();
                  for (let user of res1.data.data.users) {
                  
                      userMap.set(user.userId, user);
                 
                  }
                  for (let user of res.data.data.users) {
                    user.userInfo = userMap.get(user.userId);
                  }
                  this.list.push(...res.data.data.users)
                  this.finished = res.data.data.users.length < 15
                }
              })
          }
        })
      },
      onClickLeft() {
        routerUtil.back()
      },
      onClickRight() {
      },
      onSearch() {
        if (this.search == "") {
          this.searchUid = null
        } else {
          if (isNaN(Number(this.search, 10))) {
            Toast("请输入组长ID")
            return
          }
          const uid = parseInt(this.search);
          this.searchUid = uid;
        }
        this.searchType = parseInt(this.checked)
        this.list = [];
        this.onRefresh()
      },
      onLoad() {
        this.getList(true)
      },
      onRefresh() {
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.getList()
      },
      onEnableTapped(li) {
        this.confirm = true;
        this.item = li;
        this.isEnable = true;
      },
      onDisableTapped(li) {
        this.confirm = true;
        this.item = li;
        this.isEnable = false;
      },
      onConfirmTapped() {
        this.confirm = false;
        const status = this.isEnable ? 0 : 1;
        this.$request.postJson('/api/user/pay_group/member/change_status', {
          groupId: this.groupInfo.id,
          userId: this.item.userId,
          status: status
        }).then((res) => {
          if (res.data.code == 0) {
            this.item.status = status
          }
        })
      },
      onUidTapped(li) {
        copy(li.userId);
        Toast('组长ID已复制');
      },
      onInviteCodeTapped(li) {
        copy(li.code);
        Toast('组ID已复制');
      },
      onParentIdTapped(li) {
        if (!li.parentId) {
          return
        }
        copy(li.parentId);
        Toast('上级ID已复制');
      },
      onCopyUserIdTapped(li) {
        this.onUidTapped(li)
      },
      onIncomeTapped(li) {
        this.$router.push({
          name: 'twolevel',
          params: {
            userId: li.userId
          }
        });
      },
      getDisplayJoinTime(time) {
        const date = new Date(time);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const min = date.getMinutes();
        const sec = date.getSeconds();
        return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
      }
    },
  }
  </script>
  <style scoped lang="less">
    /* 全局容器样式 */
    .two-member-list-container {
        min-height: 100vh;
        background: linear-gradient(to bottom, #fafafa, #ffffff);
        color: #333333;
    }
    
    /* 内容包装器 */
    .content-wrapper {
        max-width: 1200px;
        margin: 0 auto;
        padding: 16px;
    }
    
    /* 搜索区域样式 */
    .search-section {
        background: #ffffff;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        border: 1px solid #e0e0e0;
    }
    
    .search-bar {
        margin-bottom: 16px;
        background: transparent;
        
        :deep(.van-search) {
            background-color: transparent !important;
        }
        
        :deep(.van-search__content) {
            background-color: #f5f5f5 !important;
            border: 1px solid #e0e0e0 !important;
            border-radius: 12px !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;
        }
        
        :deep(.van-search__content:focus-within) {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        
        :deep(.van-field__input) {
            color: #333333 !important;
            background: #f5f5f5 !important;
        }
        
        :deep(.van-field__placeholder) {
            color: #909090 !important;
        }
    }
    
    .search-btn {
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        cursor: pointer;
    }
    
    /* 搜索类型选择样式 */
    .search-type-wrapper {
        margin-top: 12px;
    }
    
    .radio-group {
        :deep(.van-radio__label) {
            font-size: 14px;
            color: #999999;
        }
        
        :deep(.van-radio__icon) {
            border-color: #e0e0e0;
        }
        
        :deep(.van-radio__icon--checked) {
            color: #333333;
        }
        
        :deep(.van-radio__icon--checked .van-icon) {
            background-color: #FFD700;
            border-color: #FFD700;
        }
    }
    
    /* 成员列表容器 */
    .member-list {
        padding-bottom: 20px;
    }
    
    /* 成员卡片样式 */
    .member-card {
        background: #ffffff;
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 1px solid #e0e0e0;
    }
    
    .member-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
        border-color: #cccccc;
    }
    
    /* 成员头部信息 */
    .member-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 16px;
        border-bottom: 1px solid #e0e0e0;
        color: #333333;
    }
    
    .avatar-container {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 16px;
        border: 3px solid #FFD700;
    }
    
    .avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .member-info {
        flex: 1;
        color: #333333;
    }
    
    .member-name {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 8px;
    }
    
    .join-time {
        font-size: 14px;
        color: #666666;
    }
    
    /* 成员数据信息 */
    .member-data {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 16px;
        margin-bottom: 20px;
        border-top: 1px solid #e0e0e0;
        padding-top: 16px;
    }
    
    .data-item {
        text-align: center;
        padding: 12px;
        background: #f5f5f5;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #e0e0e0;
    }
    
    .data-item:hover {
        background: #fff9e6;
        transform: translateY(-1px);
    }
    
    .data-value {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 6px;
    }
    
    .data-label {
        font-size: 14px;
        color: #888888;
    }
    
    /* 操作按钮样式 */
    .action-buttons {
        display: flex;
        justify-content: center;
        margin-top: 16px;
    }
    
    .action-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 12px;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        width: 100%;
    }
    
    .income-btn {
        background: #FFD700;
        color: #333333;
    }
    
    .income-btn:hover {
        background: #ffc700;
        transform: translateY(-1px);
    }
    
    .icon-income {
        font-size: 16px;
    }
    
    /* 确认弹窗样式 */
    .confirm-dialog {
        width: 280px;
        padding: 24px;
        text-align: center;
        background: #f5f5f5;
        border-radius: 12px;
    }
    
    .confirm-content {
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
    }
    
    /* 响应式设计 */
    @media (max-width: 768px) {
        .member-data {
            grid-template-columns: 1fr;
        }
        
        .action-buttons {
            flex-direction: column;
        }
        
        .action-btn {
            justify-content: center;
        }
    }
    
    /* Vant 组件样式覆盖 */
    :deep(.van-radio__label) {
        color: #999999;
    }
    
    :deep(.van-radio__input--checked .van-radio__icon) {
        background-color: #FFD700;
        border-color: #FFD700;
    }
    
    :deep(.van-radio__input--checked .van-radio__label) {
        color: #FFD700;
    }
    
    /* 导航栏样式覆盖 */
    :deep(.van-nav-bar) {
        background-color: #FFD700 !important;
        color: #333333 !important;
    }
    
    :deep(.van-nav-bar__title) {
        color: #333333 !important;
    }
    
    :deep(.van-nav-bar__text) {
        color: #333333 !important;
    }
    
    :deep(.van-icon) {
        color: #333333 !important;
    }
    

    
    :deep(.van-list__loading) {
        padding: 20px 0;
    }
    
    :deep(.van-list__finished-text) {
        color: #999;
        padding: 20px 0;
    }
    
    /* 动画效果 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
  </style>
